















































import {Vue, Component, Emit} from 'vue-property-decorator'

@Component({
  name: 'c-call-order-modal'
})
export default class CallOrderModal extends Vue {
  name: string = ''
  phone: string = ''

  @Emit()
  close () {}

  @Emit()
  submit () {
    return {
      name: this.name,
      phone: this.phone
    }
  }
}
